import { render, staticRenderFns } from "./CalcsOverview.vue?vue&type=template&id=b339ca66&scoped=true"
import script from "./CalcsOverview.vue?vue&type=script&lang=js"
export * from "./CalcsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b339ca66",
  null
  
)

export default component.exports